// extracted by mini-css-extract-plugin
export default {"coupon-form":"coupon-form_qnOU_","save-button":"save-button_pszud","buy-one-get-more-wrapper":"buy-one-get-more-wrapper_UpjAE"};